import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Type } from 'class-transformer';
import {
  IsNumber,
  IsOptional,
  IsString,
  IsDateString,
  Min,
} from 'class-validator';

export class ItinerarioFiltroDto {
  @ApiPropertyOptional({
    description: 'ID o Nombre del puerto de embarque (POL)',
  })
  @IsOptional()
  @IsString()
  polId?: string;

  @ApiPropertyOptional({
    description: 'ID o Nombre del puerto de descarga (POD)',
  })
  @IsOptional()
  @IsString()
  podId?: string;

  @ApiPropertyOptional({ description: 'Fecha desde (ETD)' })
  @IsOptional()
  @IsDateString()
  dateFrom?: string;

  @ApiPropertyOptional({ description: 'Fecha hasta (ETD)' })
  @IsOptional()
  @IsDateString()
  dateTo?: string;

  @ApiPropertyOptional({ description: 'Fecha ETA desde' })
  @IsOptional()
  @IsDateString()
  dateEtaFrom?: string;

  @ApiPropertyOptional({ description: 'Fecha ETA hasta' })
  @IsOptional()
  @IsDateString()
  dateEtaTo?: string;

  @ApiPropertyOptional({ description: 'ID o Nombre de la naviera (Carrier)' })
  @IsOptional()
  @IsString()
  carrierId?: string;

  @ApiPropertyOptional({ description: 'Nombre de la nave (Vessel)' })
  @IsOptional()
  @IsString()
  vesselId?: string;

  @ApiPropertyOptional({
    description: 'Tipo de Servicio (1 = Liner, 2 = Charter)',
  })
  @IsOptional()
  @IsNumber()
  @Type(() => Number)
  typeOfServiceId?: number;

  @ApiPropertyOptional({ description: 'Número de página', default: 1 })
  @IsOptional()
  @IsNumber()
  @Min(1)
  @Type(() => Number)
  page?: number = 1;

  @ApiPropertyOptional({ description: 'Registros por página', default: 10 })
  @IsOptional()
  @IsNumber()
  @Min(1)
  @Type(() => Number)
  limit?: number = 10;
}

export class ItinerarioItemDto {
  @ApiProperty()
  voyageId!: number;

  @ApiProperty()
  vesselName!: string;

  @ApiProperty()
  voyageNumber!: string;

  @ApiProperty()
  carrierName!: string;

  @ApiPropertyOptional()
  carrierFullName?: string;

  @ApiProperty()
  polName!: string;

  @ApiProperty()
  podName!: string;

  @ApiProperty()
  etd!: string;

  @ApiPropertyOptional()
  eta?: string;

  @ApiProperty()
  transitTime!: number;

  @ApiPropertyOptional({
    description: 'Full route stops including intermediate points',
    type: () => [VoyageCallDto],
  })
  route?: VoyageCallDto[];

  /** ID numérico del puerto de embarque — requerido para el Wizard de Instructivo de Embarque */
  @ApiPropertyOptional({
    description: 'LocationId del POL (requerido para I/E)',
  })
  portOfLoadingId?: number;

  /** ID numérico del puerto de descarga — requerido para el Wizard de Instructivo de Embarque */
  @ApiPropertyOptional({
    description: 'LocationId del POD (requerido para I/E)',
  })
  portOfDischargeId?: number;

  /** True si el voyage call tiene al menos 1 booking activo. Habilita el boton "INST. EMBQUE." en el listado. */
  @ApiPropertyOptional({
    description:
      'Indica si el voyage tiene bookings activos (para habilitar el boton de Instructivo de Embarque)',
  })
  hasActiveBookings?: boolean;
}

export class ItinerarioRespuestaDto {
  @ApiProperty({ type: [ItinerarioItemDto] })
  data!: ItinerarioItemDto[];

  @ApiProperty()
  total!: number;

  @ApiProperty()
  page!: number;

  @ApiProperty()
  limit!: number;
}

export class ItinerarioDetalleDto extends ItinerarioItemDto {
  @ApiPropertyOptional({ description: 'Fecha de declaración' })
  declarationDate?: string;

  @ApiPropertyOptional({
    description: 'Full list of calls (recaladas) for this voyage',
    type: () => [VoyageCallDto],
  })
  voyageCalls?: VoyageCallDto[];

  // Voyage Deadlines (Stacking, Cutoff, Late Arrival)
  @ApiPropertyOptional({ description: 'Observaciones de Stacking' })
  remarksStacking?: string | null;

  @ApiPropertyOptional({ description: 'Fecha de Corte Documental' })
  documentalCutOffDate?: string | null;

  @ApiPropertyOptional({ description: 'Observaciones de Late Arrival' })
  remarksLateArrival?: string | null;
}

export class VoyageCallDto {
  @ApiProperty()
  portName!: string;

  @ApiPropertyOptional()
  portCode?: string;

  @ApiPropertyOptional()
  countryCode?: string;

  @ApiPropertyOptional()
  countryName?: string;

  @ApiPropertyOptional()
  eta?: string;

  @ApiPropertyOptional()
  etd?: string;

  @ApiProperty()
  isPol!: boolean;

  @ApiProperty()
  isPod!: boolean;
}
